var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 110.059 110.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_38",
    x: 0,
    y: 0,
    width: 110.059,
    height: 110.373,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22033",
    "data-name": "Group 22033",
    transform: "translate(4961.759 -13527.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20045",
    "data-name": "Group 20045",
    transform: "translate(-6242.729 12590.873)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1280.97, 936.31)",
    filter: "url(#Union_38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_38-2",
    "data-name": "Union 38",
    d: "M0,46.344A46.031,46.031,0,0,1,45.446.318L45.4.272,79.563,0S91.655.227,91.655,13.39c0,8.418.12,20.824.207,28.676q.195,2.114.2,4.278A46.029,46.029,0,1,1,0,46.344Z",
    transform: "translate(9 6)",
    fill: "#1d65ff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    x2: 17.048,
    transform: "translate(1327.04 983.541)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    x2: 17.048,
    transform: "translate(1327.04 990.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21279",
    "data-name": "Group 21279",
    transform: "translate(-4920.73 13564.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17405",
    "data-name": "Path 17405",
    d: "M3.574,30.373Z",
    transform: "translate(-3.062 -2.886)",
    fill: "#334350"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21799",
    "data-name": "Group 21799",
    transform: "translate(-1 -0.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18314",
    "data-name": "Path 18314",
    d: "M75.958,55.357,65.12,50.712a3.691,3.691,0,0,0-3.512.323L55.813,54.9a17.711,17.711,0,0,1-8.146-8.11h0l3.849-5.882a3.7,3.7,0,0,0,.306-3.486L47.173,26.572a3.709,3.709,0,0,0-3.853-2.217A12.974,12.974,0,0,0,32,37.21,33.358,33.358,0,0,0,65.321,70.53,12.974,12.974,0,0,0,78.176,59.21a3.71,3.71,0,0,0-2.218-3.853Z",
    transform: "translate(-4969.568 13537.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21698",
    "data-name": "Group 21698",
    transform: "translate(-6227.366 12578.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M6262.583-12549.627c-.184,0-.321,0-.446,0-3.1-.056-7.309-.084-12.522-.084-8.822,0-17.729.083-17.8.084v-22.087a8.756,8.756,0,0,1,1.638-3.745,8.706,8.706,0,0,1,3.1-2.574,12.347,12.347,0,0,1,5.556-1.17h20.032c.031,0,.112,0,.241,0,1.524,0,9.135.487,9.306,10.111.186,10.625,0,13.266,0,13.291a4.874,4.874,0,0,1-1.185,3.6C6269.019-12550.5,6266.356-12549.627,6262.583-12549.627Zm-22.878-11.932a1.558,1.558,0,0,0-1.556,1.557,1.558,1.558,0,0,0,1.556,1.557h15.641a1.558,1.558,0,0,0,1.556-1.557,1.558,1.558,0,0,0-1.556-1.557Zm0-7.523a1.558,1.558,0,0,0-1.556,1.557,1.558,1.558,0,0,0,1.556,1.557h24.165a1.558,1.558,0,0,0,1.557-1.557,1.558,1.558,0,0,0-1.557-1.557Z",
    transform: "translate(-4915.788 13552.919)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4ebde606cb551c6f14517681112da0aa.svg";
export { ForwardRef as ReactComponent };